export const fleetsConstants = {
  INIT: 'FETCH_FLEETS_INIT',
  SUCCESS: 'FETCH_FLEETS_SUCCESS',
  UPDATE: 'FETCH_FLEETS_UPDATE',
  ADD: 'FETCH_FLEETS_ADD',
  FAILURE: 'FETCH_FLEETS_FAILURE',
  REMOVE: 'FETCH_FLEETS_REMOVE',
  CLEAR: 'FETCH_FLEETS_CLEAR',
}
